module.exports = __webpack_public_path__ + "img/icon-3.50a22c27.png";